import React, { useState } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { BsCheckLg } from "react-icons/bs";
import { useEffect } from "react";
import Btn from "../shared/button/Btn";
import { addRoleClaim } from "../../features/admin5/admin5Slice";
import SmallSpinner from "../shared/spinners/SmallSpinner";

const Container = styled.div`
  width: 100%;
  cursor: pointer;

    .main {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      position: relative;
      margin: 0;
      .menu-list{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;
        .menu-item{
          width: 100%;
          .menu-item-title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 20px;
            background-color: ${({ theme }) => theme.secondaryBgColor};
            padding: 10px 20px;
            border-radius: 5px;
            cursor: pointer;
            span{
              font-size: var(--font-size-md);
              font-weight: var(--font-weight-lg);
            }
            .check-container{
              display: flex;
              align-items: center;
              gap: 20px;
              .title-check{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 30px;
                height: 30px;
                background-color: ${({ theme }) => theme.mainBgColor};
                border-radius: 50%;
                color: ${({ theme }) => theme.mainTextColor};
              }
            }
          }
          .menu-item-content{
              display: flex;
              flex-direction: column;
              padding-inline: 10px;
              .permission-list-title{
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  border-bottom: 1px solid ${({ theme }) => theme.mainBorderColor};
                  padding-block: 20px;
                  p{
                      font-size: var(--font-size-sm);
                      font-weight: var(--font-weight-lg);
                  }
              }
              .permission-list{
                display: flex;
                flex-direction: column;
                .permission-title{
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  border-bottom: 1px solid ${({ theme }) => theme.mainBorderColor};
                  padding: 10px;
                  p{
                      font-size: var(--font-size-sm);
                      font-weight: var(--font-weight-md);
                  }
                  .permission-check-container{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .page-check{
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: 30px;
                      height: 30px;
                      border-radius: 50%;
                      border: 2px solid ${({ theme }) => theme.mainBorderColor};
                      color: ${({ theme }) => theme.mainTextColor};
                      cursor: pointer;
                    }
                  }
                }
              }
          }
        }
      }
      .button-container{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
      }
    }
`;

const AdminRolYetkiContainer = () => {
  const dispatch = useDispatch();
  const {allClaimsByRole, adminRoleList, selectedRole, isLoadingAdd} = useSelector((state) => state.admin5)
  
  const [openedMenuItemId, setOpenedMenuItemId ] = useState(null)
  const [updatedAuthorizationList, setUpdatedAuthorizationList] = useState([])

  //! formatlama
  useEffect(() => {
    setUpdatedAuthorizationList(allClaimsByRole.map((item) => {
      return {
        ...item, 
        permission: item?.permission?.$values.map((perm) => {
          return {
            ...perm,
            permissions: perm?.permissions?.$values.map((subPerm) => {
              return {
                  ...subPerm
              }
            })
          }
        })
      }
    }))
  }, [allClaimsByRole])

  //! adminin rollerine göre tabloda işaretleme
  useEffect(() => {
    setUpdatedAuthorizationList((prevList) => {
      return prevList.map((item) => {
        const matchedClaim = adminRoleList.find((role) => role.id === item.id);
        return {
          ...item,
          havePermission: matchedClaim ? matchedClaim.havePermission : false, //? Eğer adminRoleList'te varsa, onun değerini al, yoksa false al
          permission: item.permission.map((perm) => {
            const matchedPerm = matchedClaim?.permission?.$values?.find(p => p.description === perm.description);
            return {
              ...perm,
              permissions: perm.permissions.map((subPerm) => {
                return {
                  ...subPerm,
                  havePermission: matchedPerm?.permissions?.$values?.some(p => p.description === subPerm.description) || false, //? Eğer adminRoleList'te varsa, onun değerini al, yoksa false al
                }
              })
            }
          })
        }
      })
    })
  }, [allClaimsByRole, adminRoleList])

  const handleMainPermissionToggle = (itemId) => {
    //? Tıklanan itemin id sine göre tüm permissionsları güncelle
    setUpdatedAuthorizationList((prevList) =>
      prevList.map((item) => item.id === itemId ? 
        {
          ...item,
          havePermission: !item.havePermission, //? Ana öğenin permission değerini değiştir
          permission: item.permission.map((perm) => ({
            ...perm,
            permissions: perm.permissions.map((subPerm) => ({
              ...subPerm,
              havePermission: !item.havePermission, //? Alt öğelerdeki tüm permissions'ı güncelle
            })),
          })),
        } : item
      )
    );
  };

  const handleSubPermissionToggle = (itemId, permissionId) => {
    setUpdatedAuthorizationList((prevList) =>
      prevList.map((item) =>
        item.id === itemId
          ? {
              ...item,
              permission: item.permission.map((perm) =>
                perm.$id === permissionId
                  ? {
                      ...perm,
                      permissions: perm.permissions.map((subPerm) =>
                        { return {...subPerm, havePermission: !subPerm.havePermission} }
                      ),
                    }
                  : perm
              ),
            }
          : item
      )
    );
  };

  const handleSubmit = () => {
    const updatedData = {
      roleName: selectedRole.name,
      claimIds: updatedAuthorizationList //! Tüm yetkileri dolaş ve sadece yetkili olanların idsini al
          .flatMap(item => 
              item.permission
                  .flatMap(perm => 
                      perm.permissions
                          .filter(subPerm => subPerm.havePermission)
                          .map(subPerm => subPerm.id)
                  )
          )
    }
    dispatch(addRoleClaim(updatedData)) //! adminRoleList'ten gelen claimId'leri güncelle
  }

  
  return (
    <Container>
      <div className="main">
        <div className="menu-list">
          {updatedAuthorizationList.map((item) => (
            <div className="menu-item" key={item.id} onClick={() => setOpenedMenuItemId(openedMenuItemId === item.id ? null : item.id)}>
              <div className="menu-item-title">
                <span>{item.name}</span>
                <div className="check-container">
                  <div className="title-check" onClick={(e) => {e.stopPropagation(); handleMainPermissionToggle(item.id)}}>
                    {
                      item.havePermission && <BsCheckLg />
                    }
                  </div>
                </div>
              </div>

              {openedMenuItemId === item.id && (
                <div className="menu-item-content">
                  <div className="permission-list-title">
                      <p>Sayfalar</p>
                  </div>
                  <div className="permission-list">
                    {item.permission.map((permission) => (
                      <div onClick={(e) => {e.stopPropagation(); handleSubPermissionToggle(item.id, permission.$id)}} className="permission-title">
                        <p>{permission.description}</p>
                        <div className="permission-check-container">
                          <div className="page-check">
                            {
                              permission.permissions.some((subPerm) => subPerm.havePermission) && <BsCheckLg />
                            }
                          </div> 
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="button-container">
          <Btn color="#fff" bgColor="#E85446" padding="0px 10px" width={"200px"} handleClick={handleSubmit}>{isLoadingAdd ? <SmallSpinner size={"20px"} color={"#E85446"} bgColor={"#fff"}/> : "Güncelle"}</Btn>
        </div>
      </div>
    </Container>
  );
};

export default AdminRolYetkiContainer;
